import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { matchPath, useLocation } from "react-router-dom";
import * as NAVIGATION_TITLES from "../enums/NavigationTitles";
import * as URL_PATHS from "../enums/UrlPaths";
import useUser from "./useUser";
import { removeTrailingSlash } from "../utils/Functions";

const urlPathToTitleMap = {
  [URL_PATHS.APPOINTEMENTS]: NAVIGATION_TITLES.MEETS,
  [URL_PATHS.RESERVATION_ADMINISTRATION]: NAVIGATION_TITLES.MEETS,
  [URL_PATHS.PET_DETAILS_ID]: NAVIGATION_TITLES.PET_DETAILS,
  [URL_PATHS.APPOINTEMENT_DETAILS]: NAVIGATION_TITLES.APPOINTMENT_DETAILS,
  [URL_PATHS.SINGLE_RESERVATION_ADMINISTRATION_DETAILS]:
    NAVIGATION_TITLES.APPOINTMENT_DETAILS,
  [URL_PATHS.HOME]: NAVIGATION_TITLES.HOME,
  [URL_PATHS.SETTINGS]: NAVIGATION_TITLES.ADMINISTRATION,
  [URL_PATHS.PETS]: NAVIGATION_TITLES.PETS,
  [URL_PATHS.PROFILE_EDIT]: NAVIGATION_TITLES.PROFILE,
  [URL_PATHS.ABOUT_US]: NAVIGATION_TITLES.ABOUT_US,
  [URL_PATHS.PENDING_APPOINTMENTS]: NAVIGATION_TITLES.PENDING,
  [URL_PATHS.TEMPLATE]: NAVIGATION_TITLES.TEMPLATE,
  [URL_PATHS.TEMPLATE_DETAILS_]: NAVIGATION_TITLES.TEMPLATE_DETAILS,
  [URL_PATHS.INBOX]: NAVIGATION_TITLES.INBOX,
  [URL_PATHS.CLINIC_USERS]: NAVIGATION_TITLES.CLINIC_USERS,
  [URL_PATHS.SINGLE_CLINIC_EMPLOYEES]: NAVIGATION_TITLES.EMPLOYEES,
  [URL_PATHS.SINGLE_CLINIC_WORKINGHOURS]: NAVIGATION_TITLES.WORKING_HOURS,
  [URL_PATHS.SINGLE_CLINIC_SPECIES]: NAVIGATION_TITLES.SPECIES,
  [URL_PATHS.SINGLE_CLINIC_BLOOD_DONORS]: NAVIGATION_TITLES.BLOOD_DONORS,
  [URL_PATHS.SINGLE_CLINIC_DOCUMENTCATEGORIES]:
    NAVIGATION_TITLES.DOCUMENT_CATEGORIES,
  [URL_PATHS.SINGLE_CLINIC_INFORMATIONFIELDS]:
    NAVIGATION_TITLES.INFORMATION_FIELDS,
  [URL_PATHS.FEEDBACK_SUBMIT]: NAVIGATION_TITLES.FEEDBACK,
  [URL_PATHS.SINGLE_CLINIC]: NAVIGATION_TITLES.CLINIC_GENERAL_SETTINGS, //clinic settings
  [URL_PATHS.SINGLE_CLINIC_OPTIONS]: NAVIGATION_TITLES.CLINIC_SETTINGS, //logo
  [URL_PATHS.SINGLE_CLINIC_CHANGELOGO]: NAVIGATION_TITLES.CLINIC_CHANGE_LOGO,
  [URL_PATHS.SINGLE_CLINIC_WAREHOUSE]: NAVIGATION_TITLES.CLINIC_WAREHOUSE,
  [URL_PATHS.SINGLE_USER_PERMISSIONS]: NAVIGATION_TITLES.USER_PERMISSIONS,
  [URL_PATHS.SAPS_HOME_PAGE]: NAVIGATION_TITLES.STATIONARY,
  [URL_PATHS.SINGLE_BOX_VIEW_NO_ID]: NAVIGATION_TITLES.SAPS_BOX,
  [URL_PATHS.SINGLE_PET_VIEW_NO_ID]: NAVIGATION_TITLES.PET,
  [URL_PATHS.AI_ASSISTANT]: NAVIGATION_TITLES.AI_ASSISTANT,
  [URL_PATHS.MASTER_CLINIC_USERS]: NAVIGATION_TITLES.MASTER_CLINIC_USERS,
  [URL_PATHS.SPECIES_ADMINISTRATION]: NAVIGATION_TITLES.SPECIES_MANAGMENT,
  [URL_PATHS.CLINIC_LIST]: NAVIGATION_TITLES.CLINIC_LIST,
  [URL_PATHS.SINGLE_CLINIC_OPTIONS_ID]: NAVIGATION_TITLES.CLINIC_SETTINGS,
  [URL_PATHS.SINGLE_CLINIC_USER_ID]: NAVIGATION_TITLES.CLINIC_USER_DETAIL,
  [URL_PATHS.SINGLE_CLINIC_USER]: NAVIGATION_TITLES.CLINIC_USER_DETAIL,
  [URL_PATHS.APPOINTEMENT_DETAILS_ID]: NAVIGATION_TITLES.APPOINTMENT_DETAILS,
  [URL_PATHS.PENDING_APPOINTEMENT_DETAILS_ID]:
    NAVIGATION_TITLES.APPOINTMENT_DETAILS,
  [URL_PATHS.SINGLE_CLINIC_ID]: NAVIGATION_TITLES.CLINIC_GENERAL_SETTINGS,
  [URL_PATHS.SINGLE_CLINIC_EMPLOYEES_ID]: NAVIGATION_TITLES.EMPLOYEES,
  [URL_PATHS.SINGLE_CLINIC_WORKINGHOURS_ID]: NAVIGATION_TITLES.WORKING_HOURS,
  [URL_PATHS.SINGLE_CLINIC_CHANGELOGO_ID]: NAVIGATION_TITLES.CLINIC_CHANGE_LOGO,
  [URL_PATHS.SINGLE_CLINIC_SPECIES_ID]: NAVIGATION_TITLES.SPECIES,
  [URL_PATHS.SINGLE_CLINIC_BLOOD_DONORS_ID]: NAVIGATION_TITLES.BLOOD_DONORS,
  [URL_PATHS.SINGLE_CLINIC_DOCUMENTCATEGORIES_ID]:
    NAVIGATION_TITLES.DOCUMENT_CATEGORIES,
  [URL_PATHS.SINGLE_CLINIC_INFORMATIONFIELDS_ID]:
    NAVIGATION_TITLES.INFORMATION_FIELDS,
  [URL_PATHS.SINGLE_CLINIC_WAREHOUSE_ID]: NAVIGATION_TITLES.CLINIC_WAREHOUSE,
  [URL_PATHS.SINGLE_USER_PERMISSIONS_ID]: NAVIGATION_TITLES.USER_PERMISSIONS,
  [URL_PATHS.SINGLE_RESERVATION_ADMINISTRATION_DETAILS_ID]:
    NAVIGATION_TITLES.APPOINTMENT_DETAILS,
  [URL_PATHS.SINGLE_BOX_VIEW]: NAVIGATION_TITLES.SAPS_BOX,
  [URL_PATHS.SINGLE_PET_VIEW]: NAVIGATION_TITLES.PET_DETAILS,
  [URL_PATHS.MASTER_SINGLE_CLINIC_ID]: NAVIGATION_TITLES.CLINIC,
  [URL_PATHS.SINGLE_EMPLOYEE_ID]: NAVIGATION_TITLES.EMPLOYEE_EDIT,
  [URL_PATHS.SINGLE_THERAPY_VIEW_ID]: NAVIGATION_TITLES.THERAPY,
  [URL_PATHS.USER_CHANGE_PASSWORD]: NAVIGATION_TITLES.CHANGE_PASSWORD,
  [URL_PATHS.TERMS_INTERNAL]: NAVIGATION_TITLES.TERMS_AND_CONDITIONS,
};

export default function useNavigationTitles() {
  var location = useLocation();
  const { currentClinic, roles } = useUser();
  const [locationTitle, setLocationTitle] = useState();
  const { i18n } = useTranslation();
  const { t } = useTranslation();

  useEffect(() => {
    const normalizedPath = removeTrailingSlash(location.pathname);
    const titleKey = Object.keys(urlPathToTitleMap).find((pattern) =>
      matchPath(
        { path: removeTrailingSlash(pattern), end: true },
        normalizedPath,
      ),
    );

    const title =
      urlPathToTitleMap[titleKey] ??
      (roles.master ? "Zookeeper" : `${currentClinic?.title} - Zookeeper`);

    setLocationTitle(t(title));
  }, [location.pathname, i18n.language, currentClinic?.title, roles.master, t]);

  return locationTitle;
}
